import { collection, addDoc, getDocs, doc, query, orderBy, serverTimestamp, writeBatch } from 'firebase/firestore'
import { initFirebase } from '../firebase'

const { db } = initFirebase()

export class FirebaseSuggestionService {
  constructor() {
    this.suggestionsRef = collection(db, 'suggestions')
  }

  async getSuggestions() {
    try {
      const q = query(this.suggestionsRef, orderBy('order', 'asc'))
      const querySnapshot = await getDocs(q)
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
    } catch (error) {
      console.error('Error getting suggestions:', error)
      throw error
    }
  }

  async getNextOrder() {
    try {
      const q = query(this.suggestionsRef, orderBy('order', 'desc'))
      const querySnapshot = await getDocs(q)
      if (querySnapshot.empty) return 1
      return querySnapshot.docs[0].data().order + 1
    } catch (error) {
      console.error('Error getting next order:', error)
      throw error
    }
  }

  async addSuggestion(value) {
    try {
      const order = await this.getNextOrder()
      const docRef = await addDoc(this.suggestionsRef, {
        value,
        order,
        createdAt: serverTimestamp()
      })
      return docRef.id
    } catch (error) {
      console.error('Error adding suggestion:', error)
      throw error
    }
  }

  async updateOrder(suggestionId, newOrder, oldOrder) {
    try {
      const batch = writeBatch(db)
      
      const suggestions = await this.getSuggestions()
      suggestions.forEach(suggestion => {
        if (suggestion.id === suggestionId) {
          batch.update(doc(db, 'suggestions', suggestion.id), { order: newOrder })
        } else if (newOrder > oldOrder && suggestion.order > oldOrder && suggestion.order <= newOrder) {
          batch.update(doc(db, 'suggestions', suggestion.id), { order: suggestion.order - 1 })
        } else if (newOrder < oldOrder && suggestion.order >= newOrder && suggestion.order < oldOrder) {
          batch.update(doc(db, 'suggestions', suggestion.id), { order: suggestion.order + 1 })
        }
      })

      await batch.commit()
    } catch (error) {
      console.error('Error updating order:', error)
      throw error
    }
  }

  async deleteSuggestion(id) {
    try {
      const suggestionDoc = await doc(db, 'suggestions', id)
      const suggestion = (await getDocs(suggestionDoc)).data()
      const order = suggestion.order

      const batch = writeBatch(db)
      
      batch.delete(suggestionDoc)

      const suggestions = await this.getSuggestions()
      suggestions.forEach(s => {
        if (s.order > order) {
          batch.update(doc(db, 'suggestions', s.id), { order: s.order - 1 })
        }
      })

      await batch.commit()
    } catch (error) {
      console.error('Error deleting suggestion:', error)
      throw error
    }
  }
} 